import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ErrorCode } from '@blk/wealth-web-endpoint';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';
import { ApplicationNames } from '@ddt-web/domain';
import * as get from 'lodash/get';
import * as toPairsIn from 'lodash/toPairsIn';

import { PasSecurityDetailsPartialError } from '../../models';
import { ErrorObject } from '../../models/error-object';
import { WwePortfolioAnalysisPartialError } from '../../models/wwe-errors/wwe-portfolio-analysis-partial-error';
import { WweSecurityDetailsPartialError } from '../../models/wwe-errors/wwe-security-details-partial-error';
import { AbstractErrorHandlerService } from '../abstract-error-handler.service';
import { ErrorHelperService } from '../error-helper.service';
import { ErrorPopupService } from '../error-popup.service';

@Injectable()
export class DashboardAnalysisErrorHandlerService extends AbstractErrorHandlerService {
	private flagErrorConfigs = ['details', 'risk', 'performance'];

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(
			contentService,
			errorPopupService,
			tealiumAnalyticsService,
			errorHelperService
		);
	}

	public handleError(error): void {
		const configName = get(error, 'configName', '');

		// Apply this just for PC Dashboard
		if (error instanceof ErrorObject && this.flagErrorConfigs.includes(configName) && this.errorHelperService.getApplicationName() === ApplicationNames.PORTFOLIO_CENTRE) {
			// Setup scope variables
			const errorObject = error.responseJson;
			const isPartialError = errorObject instanceof WwePortfolioAnalysisPartialError || errorObject instanceof WweSecurityDetailsPartialError || errorObject instanceof PasSecurityDetailsPartialError;

			// Set error severity
			this.errorSeverity = isPartialError ? ERROR_SEVERITY.ERROR : ERROR_SEVERITY.CRITICAL;

			if (isPartialError) {
				const errorCodes = errorObject.errorCodes;
				const errorCodesList = toPairsIn(errorCodes);

				const defaultErrorMessage =
					errorObject instanceof WwePortfolioAnalysisPartialError
						? this.contentService.get('PORTFOLIO_ANALYSIS_COMMON_ERROR', ErrorDCR.PORTFOLIO_ANALYSIS_COMMON_ERROR)
						: this.contentService.get('SECURITY_DETAILS_COMMON_ERROR', ErrorDCR.SECURITY_DETAILS_COMMON_ERROR);

				// Log each error to console
				errorCodesList.forEach(error => this.logErrorsToConsole(error[0], error[1], configName, defaultErrorMessage));

			} else {
				console.error('There was an error while retrieving data for config: ' + configName, errorObject);
			}

			this.handleErrorTracking('unabletoprocessrequest', this.errorSeverity);
		} else {
			this.nextHandler.handleError(error);
		}
	}

	private logErrorsToConsole(errorKey: string, error: ErrorCode, configName: string, defaultMessage: string): void {
		const message = error.description || defaultMessage;
		console.error(`There was an error while retrieving data for config: ${configName} and portfolioId: ${errorKey}`, `${error.code}: ${message}`);
	}
}
